import React from 'react';

import useAppInfo from '../../../common/hooks/useAppInfo';

import { MUILanguageSwitcher } from './MUILanguageSwitcher';

import './Footer.scss';

export default function Footer() {
  const { displayAppVersion, features } = useAppInfo();
  const localizingEnabled = features.localizingEnabled;
  return (
    <footer className="text-center py-2 text-muted footfx">
      Version&nbsp;<span>{displayAppVersion}</span>&nbsp;© {new Date().getFullYear()} Elligo Health Research, Inc. All
      Rights Reserved
      {localizingEnabled && <MUILanguageSwitcher />}
    </footer>
  );
}
